import {
    ERROR_MESSAGES,
    SUCCESS_MESSAGES,
} from 'utils/constants/toastMessages';

import { API_UPDATE_MAKER_REQUEST } from 'utils/API/apiUrls';
import { POST } from 'utils/fetchWrappers';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import { FormElems } from 'components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { toast } from 'react-toastify';

const CheckerApprovalForm = ({
    requestDetails,
    auth,
    closePopup,
    showLoader,
    hideLoader,
    isBDOnboarding,
    checkerRemarks,
}) => {


    const [comment, setComment] = useState(null);
    const [isApproved, setIsApproved] = useState('');
    const [switchState, setSwitchState] = useState({
        goLive: false,
    });

    const handleFormSubmit = async event => {
        event.preventDefault();

        const metaDataRequest = {
            isLiveEnabled: switchState.goLive,
        };

        const payload = {
            makerRequestId: requestDetails.makerRequestId,
            remarks: comment,
            eventType: requestDetails.eventType,
            status: isApproved ? 'APPROVED' : 'REJECTED',
            remarkBy: auth.userDetails.email || '',
        }
        if (checkerRemarks && checkerRemarks.length > 0 && checkerRemarks.some(item => item.status !== null)) {
            payload.checkerRemarks = checkerRemarks;
        }
        if (isBDOnboarding) {
            payload['metadata'] = JSON.stringify(metaDataRequest);
        }

        try {
            showLoader && showLoader(); // Make sure showLoader exists
            const response = await POST(API_UPDATE_MAKER_REQUEST, payload, {});

            const { data } = response;
            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                toast.success(SUCCESS_MESSAGES.APPLICATION_UPDATED_SUCCESSFULLY);
                closePopup();
            } else {
                toast.error(data.errorMessage);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.errorMessage || ERROR_MESSAGES.FALLBACK_ERROR;
            toast.error(errorMessage);
        } finally {
            if (typeof hideLoader === 'function') {
                hideLoader(); // Ensure hideLoader is called only if defined
            }else{
                console.log("inelse finally block ");
            }
        }
    };
        return (
        <form onSubmit={handleFormSubmit} className="checker-form">
            <div className="form-field">
                <p className="label">Remark</p>

                <FormElems.TextArea
                    handleChange={value => setComment(value)}
                    placeholder="Please enter your remark"
                    isRequired
                />
            </div>

            {isBDOnboarding ? (
                <div className="form-field form-field-switch">
                    <label className="switch">
                        <input
                            type="checkbox"
                            checked={switchState.isSettlementEnable}
                            onChange={() => {
                                setSwitchState({
                                    ...switchState,
                                    goLive: !switchState.goLive,
                                });
                            }}
                        />
                        <span className="slider round" />
                    </label>
                    <p className="label">Live Merchant</p>
                </div>
            ) : (
                <></>
            )}

            <div className="form-section">
                <FormElems.Button
                    buttonType="secondary"
                    text="REJECT"
                    id="back-btn"
                    handleClick={() => setIsApproved(false)}
                    customClass="back-btn"
                />
                <FormElems.Button
                    id="next-btn"
                    buttonType="primary"
                    text="APPROVE"
                    handleClick={() => setIsApproved(true)}
                />
            </div>
        </form>
    );
};

CheckerApprovalForm.propTypes = {
    closePopup: PropTypes.func,
    isBDOnboarding: PropTypes.bool,
    requestDetails: PropTypes.object,
    auth: PropTypes.object,
    eventType: PropTypes.string,
    showLoader: PropTypes.func,
    hideLoader: PropTypes.func,
};

export default CheckerApprovalForm;
